"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var header_styles_1 = require("./header.styles");
var sortingArrow_icon_1 = require("../../../svg/sortingArrow.icon");
function HeaderColumn(props) {
    var className = props.className ? header_styles_1.header + " " + props.className : header_styles_1.header;
    if (props.isCurrentSort) {
        className = className + " " + header_styles_1.activeSort;
    }
    var isSortActive = props.isCurrentSort === undefined ? "false" : props.isCurrentSort + "";
    var sortDirection = props.isTimeField && isSortActive === "true"
        ? props.sortDirection * -1
        : props.sortDirection;
    var isSortAscending = props.sortDirection === undefined ? "false" : (sortDirection === 1) + "";
    return (React.createElement("div", { id: props.id, "data-qa": "header", className: className, onClick: props.onClick, "sort-active": isSortActive, "sort-ascending": isSortAscending },
        props.children,
        props.sortDirection && (React.createElement(sortingArrow_icon_1.SortingArrowIcon, { direction: sortDirection, active: props.isCurrentSort }))));
}
exports.HeaderColumn = HeaderColumn;
function Header(props) {
    var headers = React.Children.map(props.children, function (child) {
        var isCurrentSort = props.sorting.field === child.props.sortField;
        return React.cloneElement(child, {
            isCurrentSort: isCurrentSort,
            sortDirection: isCurrentSort ? props.sorting.direction : -1,
            onClick: function () {
                props.sort(child.props.sortField);
            },
        });
    });
    return React.createElement("div", { className: header_styles_1.headerWrapper }, headers);
}
exports.Header = Header;
